export default __webpack_public_path__ + "static/media/necklace.dda8331c.jpg";